import React from "react";
import ClickableBatch from "../../../clickableBatch/clickableBatch";

/** Cell value shape for {@link ClickableBadgeWithOnClickEmitter}. */
export interface ClickableBadgeWithOnClickEmitterValue {
  /** Row/order identifier emitted back to the table consumer on click. */
  id: string;
  /** Text rendered inside the clickable badge. */
  value: string;
}

/** Props for {@link ClickableBadgeWithOnClickEmitter}. */
interface ClickableBadgeWithOnClickEmitterProps {
  /** Cell value carrying the identifier and the badge label. */
  value: ClickableBadgeWithOnClickEmitterValue;
  /**
   * Optional click handler. When provided, it is invoked with the cell's
   * `id` so a parent `RisaCustomTable` consumer can react to the badge click.
   */
  onClick?: (id: string) => void;
}

/**
 * Table cell that renders a clickable badge and emits the row's `id` via an
 * optional `onClick` callback. Stops click propagation so the row handler
 * does not also fire.
 *
 * @param props - Cell value and optional click handler
 * @returns Clickable badge cell
 */
export const ClickableBadgeWithOnClickEmitter: React.FC<
  ClickableBadgeWithOnClickEmitterProps
> = ({ value, onClick }) => {
  return (
    <div
      className="table-cell-clickable-badge w-full"
      onClick={(e) => e.stopPropagation()}
    >
      <ClickableBatch text={value.value} onClick={() => onClick?.(value.id)} />
    </div>
  );
};

export default ClickableBadgeWithOnClickEmitter;
